export default "__VITE_ASSET__C_4n9uXO__"